// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"eXlbyJGODQYQbBvc"};